export default "__VITE_ASSET__WXHCrgzk__"